import React, { useCallback, useState } from 'react'
import fileDownload from 'js-file-download'

import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks/effects'

import { generateScrapingEngineReport } from '../../rest'
import { ScrapingEngineReportForm } from '../forms'

const ScrapingEngineReportPage = () => {
  useDocumentTitle('Reports - Scraping engine')
  const [isGeneratingReport, setIsGeneratingReport] = useState(false)

  const generateReport = useCallback(
    async filters => {
      const { dateRange, userIds } = filters

      try {
        setIsGeneratingReport(true)
        const [startDateMoment, endDateMoment] = dateRange
        const reportReponse = await generateScrapingEngineReport({
          startDate: startDateMoment.format('YYYY-MM-DD'),
          endDate: endDateMoment.format('YYYY-MM-DD'),
          userIds,
        })

        fileDownload(reportReponse.data, 'ScrapingEngineReport.csv')
        setIsGeneratingReport(false)
      } catch ({ response }) {
        showErrorNotification({
          message: 'Failed to generate report.',
          description: response.statusText,
        })
      }
    },
    [setIsGeneratingReport],
  )

  const handleSubmit = useCallback(filters => generateReport(filters), [
    generateReport,
  ])

  return (
    <ScrapingEngineReportForm
      onSubmit={handleSubmit}
      isGeneratingReport={isGeneratingReport}
    />
  )
}

export default ScrapingEngineReportPage
